import {Channel} from "../synth/synth.js";
import {Config} from "../synth/SynthConfig.js";

// Use only arranged patterns, including bends. Keep one stable range per track.
export function fittedBaseOctave(channel: Channel, visibleOctaves: number, fallback: number): number {
    const pitches: number[] = [];
    for (const id of new Set(channel.bars)) {
        if (!id) continue;
        for (const note of channel.patterns[id - 1].notes) {
            for (const pitch of note.pitches) for (const pin of note.pins) pitches.push(pitch + pin.interval);
        }
    }
    if (!pitches.length) return fallback;
    let low = Infinity, high = -Infinity;
    for (const pitch of pitches) { low = Math.min(low, pitch); high = Math.max(high, pitch); }
    let best = fallback, bestCount = -1, bestDistance = Infinity;
    for (let base = 0; base <= Config.pitchOctaves - visibleOctaves; base++) {
        const count = pitches.filter(p => p >= base * 12 && p <= (base + visibleOctaves) * 12).length;
        const distance = Math.abs((base + visibleOctaves / 2) * 12 - (low + high) / 2);
        if (count > bestCount || (count === bestCount && distance < bestDistance)) {
            best = base; bestCount = count; bestDistance = distance;
        }
    }
    return best;
}
